import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Card, Tooltip } from "antd";
import { Form, Formik } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";

import PatientBroadcast from "./components/Patient/patient";
import EmployeeBroadcast from "./components/Employee/employee";
import FilterBroadcast from "./components/Appointments/filterBroadcast";
import Layout from "../../components/layout";
import BroadcastService from "../../service/BroadcastUserService";
import CommonService from "../../service/CommonService";
import LoadingSpinner from "../../components/loadingSpinner";
import AntRadioLarge from "../../components/antRadioLarge";
import CustomButton from "../../components/customButton";

import loginService from "../../service/login";
import {
  checkUrl,
  MOBILE_WIDTH,
  NumericRegex,
  PRACTICE_EDITION_WHITELABEL,
} from "../../constants/constants";
import { setPopup } from "../../actions/popupAction";

import {
  crossIcon,
  MessageLogIcon,
  QuestionMarkIcon,
  rcsIconMain,
  ReportsButtonIcon,
  SettingsIcon,
} from "../../assets/svg";
import MobileMenu from "../../components/mobileMenu";
import NewBroadcastMob from "./components/NewBroadcastMob";
import useWindowDimensions from "../../components/custom-hooks/useWindowDimensions";
import MobileHeader from "../../components/header/mobileHeader";
import Templates from "./components/Templates";
import "./styles.scss";
import CustomModal from "../../components/customModal";
import CustomLabel from "../../components/customLabel";
import CustomInput from "../../components/customInput";
import { SingleFormikSelect } from "../../components/select/singleSelect";

const throttleTypes = [
  { name: "Minute(s)", id: "mins" },
  { name: "Hour(s)", id: "hours" },
];

const Broadcast = (props) => {
  const broadcastService = new BroadcastService();
  const commonservice = new CommonService();

  const history = useHistory();

  const [state, setState] = useState({
    uploadStatus: false,
    activeTab: "patient",
    loading: false,
    optionSelected: false,
    emailTemplateData: {},
    showPopup: false,
    isRcsForBroadcast: false,
    isRcsEnableAccountLevel: false,
    initialValues: {
      isEnabled: false,
      throttleType: null,
      throttleTypeValue: null,
      throttleNumber: null,
    },
  });
  const [editDeleteAccess, setEditDeleteAccess] = useState(0);
  const { width } = useWindowDimensions();


  const updateStatus = () => {
    setState((st) => ({
      ...st,
      uploadStatus: true,
      loading: true,
    }));

    const interval = setInterval(() => {
      broadcastService.getUploadStatus().then((data) => {
        if (!data.status) {
          setState((st) => ({
            ...st,
            uploadStatus: false,
            loading: false,
          }));

          clearInterval(interval);
        }
      });
    }, 5000);
  };

  const getLivechatConfiguration = async () => {
    const listResponse = await commonservice.getLivechatConfiguration();
    const isRcsEnableAccountLevel = loginService.getEnableRcs();

    const { isRcsForBroadcast } = listResponse;

    setState((st) => ({
      ...st,
      isRcsForBroadcast,
      isRcsEnableAccountLevel: isRcsEnableAccountLevel,
    }));
  };

  const toggle = (tab) => {
    setState((st) => ({
      ...st,
      activeTab: tab,
      optionSelected: true,
      emailTemplateData: {},
    }));

    history.push({
      search: `?tab=${tab}`,
    });
  };

  const backButtonClicked = () => {
    setState((st) => ({
      ...st,
      activeTab: "patient",
      optionSelected: false,
    }));
    history.push("/broadcast");
  };

  const showReports = async () => {
    history.push("/broadcast/report");
  };

  const showMessageLogs = async () => {
    history.push("/broadcast/messageLog");
  };

  const showMessageLog = async () => {
    history.push("/broadcast/messageLog");
  };

  const showThrottlePopup = async () => {
    setState((st) => ({
      ...st,
      showPopup: true,
    }));
  };

  const closeThrottlePopup = async () => {
    setState((st) => ({
      ...st,
      showPopup: false,
    }));
  };

  const checkTokenStatus = async () => {
    const token = loginService.getToken();

    if (!token) {
      history.push("/login");
    }

    const user = loginService.getDecodedToken().payload;

    if (!user.broadcastAccess) {
      checkUrl(user, history);
    }
  };

  const checkUploadStatus = async () => {
    const result = await broadcastService.getUploadStatus();

    setState((st) => ({
      ...st,
      uploadStatus: result && result.status,
      loading: false,
    }));
  };

  const getThrottleConfigs = async () => {
    const data = await broadcastService.getThrottleConfig();
    setState((st) => ({
      ...st,
      initialValues: {
        ...data,
        // A never-configured practice's default record can come back with
        // throttleNumber/throttleTypeValue of 0 instead of null; a genuinely
        // saved value can never be 0 (validation requires > 0), so normalize
        // it to null to avoid showing an invalid "0" default in the form.
        throttleNumber: data.throttleNumber || null,
        throttleTypeValue: data.throttleTypeValue || null,
        throttleType: data.throttleType
          ? {
              id: data.throttleType,
              name: throttleTypes.find((val) => val.id === data.throttleType)
                .name,
            }
          : null,
      },
    }));
  };

  useEffect(() => {
    const {
      broadcastAccess,
      liveAgentAccess,
      liveChatAccess,
      editDeleteAccess,
      reportOnlyAccess,
    } = loginService.getUser();
    setEditDeleteAccess(editDeleteAccess);

    if (!broadcastAccess) {
      if (reportOnlyAccess) {
        history.push("/broadcast/report");
      } else if (liveAgentAccess) {
        history.push("/chat-agent");
      } else if (liveChatAccess) {
        history.push("/chat");
      } else {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `You do not have access!`,
        });
        loginService.Logout();
        history.push("/");
      }
    } else {
      checkUploadStatus();
      checkTokenStatus();
      getThrottleConfigs();
      getLivechatConfiguration();
    }
  }, []);

  const { uploadStatus, activeTab } = state;

  const handleEmailTemplateData = (data, edit = false) => {
    setState((st) => ({
      ...st,
      emailTemplateData: { ...data, editTemplate: edit },
      activeTab: "template",
    }));
  };

  const updateThrottleConfig = async (values) => {
    const data = {
      ...values,
      ...(values.isEnabled
        ? {
            throttleType: values.throttleType?.id,
            throttleNumber: Number(values.throttleNumber),
            throttleTypeValue: Number(values.throttleTypeValue),
          }
        : {}),
    };
    delete data.id;

    await broadcastService.updateThrottleConfig(state.initialValues.id, data);
    setState((st) => ({
      ...st,
      showPopup: false,
      initialValues: {
        ...values,
      },
    }));
    props.setPopup({
      customPopupMessage: true,
      messageType: "success",
      message: "Throttle has been successfully adjusted.",
    });
  };

  const throttleNumberValidation = Yup.number()
    .nullable()
    .required("Throttle Value is required")
    .moreThan(0, "Throttle Value must be greater than 0")
    .test(function(value) {
      const freq = this.parent.throttleTypeValue;
      const unit = this.parent.throttleType?.id;
      const maxThrottleValue = state.initialValues.maxThrottleValue;
      if (!value || !freq || !unit || !maxThrottleValue) {
        return true;
      }

      const freqInMinutes =
        unit === "hours" ? freq * 60 : unit === "days" ? freq * 1440 : freq;
      const maxValue = freqInMinutes * maxThrottleValue;
      const unitLabel =
        unit === "hours" ? "hours" : unit === "days" ? "days" : "minutes";

      if (value > maxValue) {
        return this.createError({
          path: this.path,
          message: `Throttle Value cannot be greater than ${maxValue} for ${freq} ${unitLabel}`,
        });
      }
      return true;
    });

  const schema = Yup.object().shape({
    isEnabled: Yup.boolean(),
    throttleNumber: Yup.number()
      .nullable()
      .when("isEnabled", {
        is: true,
        then: throttleNumberValidation,
      }),
    throttleType: Yup.object()
      .nullable()
      .when("isEnabled", {
        is: true,
        then: Yup.object()
          .nullable()
          .required("Throttle Type is required"),
      }),
    throttleTypeValue: Yup.number()
      .nullable()
      .when("isEnabled", {
        is: true,
        then: Yup.number()
          .nullable()
          .required("Throttle Frequency is required")
          .test(function(value = "") {
            if (!value && value !== 0) {
              return this.createError({
                path: this.path,
                message: "Throttle Frequency is required",
              });
            }

            if (value === 0) {
              return this.createError({
                path: this.path,
                message: "Throttle Frequency must be greater than 0",
              });
            }

            const unit = this.parent.throttleType?.id;
            if (unit === "mins" && value > 1440) {
              return this.createError({
                path: this.path,
                message:
                  "Throttle Frequency cannot be greater than 1440 minutes",
              });
            }
            if (unit === "hours" && value > 24) {
              return this.createError({
                path: this.path,
                message: "Throttle Frequency cannot be greater than 24 hours",
              });
            }
            if (unit === "days" && value > 1) {
              console.log("a");
              return this.createError({
                path: this.path,
                message: "Throttle Frequency cannot be greater than 1 day",
              });
            }
            return true;
          }),
      }),
  });

  return (
    <>
      {state.showPopup && (
        <Formik
          enableReinitialize
          initialValues={state.initialValues}
          validationSchema={schema}
          validateOnMount
        >
          {({
            isValid,
            values,
            setFieldValue,
            setFieldTouched,
            validateForm,
            dirty,
            errors,
          }) => {
            const isSaveButtonEnabled = values.isEnabled
              ? dirty &&
                values.throttleNumber &&
                values.throttleType &&
                values.throttleTypeValue
              : true;
            return (
              <Form className="login-form">
                <CustomModal
                  title={
                    <>
                      Adjust Throttle
                      <Tooltip title="Close">
                        <span
                          className="close-icon-add-new"
                          onClick={closeThrottlePopup}
                        >
                          {crossIcon}
                        </span>
                      </Tooltip>
                    </>
                  }
                  handleCancel={closeThrottlePopup}
                  handleDelete={() => updateThrottleConfig(values)}
                  isVisible={state.showPopup}
                  submitButtonText="Save"
                  cancelButtonText="Cancel"
                  customClass="custom-throttle-modal"
                  disabled={!dirty || (!isSaveButtonEnabled || !isValid)}
                >
                  <div className="inner-box padding-2 margin-bottom-2">
                    <section className="form-row mb-5">
                      <CustomInput
                        type="switch"
                        pretext="Enable Throttling"
                        name="isEnabled"
                        active={values.isEnabled}
                        required
                        onChange={(value) => {
                          setFieldValue("isEnabled", value);
                          if (!value) {
                            setFieldValue("throttleNumber", null);
                            setFieldValue("throttleTypeValue", null);
                            setFieldValue("throttleType", null);
                          }
                          setTimeout(validateForm, 0);
                        }}
                      />
                    </section>
                  </div>
                  {values.isEnabled && (
                    <>
                      <div className="modal-form-row mb-5">
                        <CustomLabel title="Throttle Value" />
                        <section className="form-row">
                          <CustomInput
                            className="custom-form-input mt-2"
                            placeholder="Enter a number"
                            name="throttleNumber"
                            allowedRegex={NumericRegex}
                          />
                        </section>
                      </div>
                      <div className="modal-form-row mb-5">
                        <div className="frequency-label">
                          <CustomLabel title="Throttle Frequency" />
                          <Tooltip title="Throttle frequency works based on shift start time.">
                            <figure>
                              <QuestionMarkIcon />
                            </figure>
                          </Tooltip>
                        </div>
                        <section className="frequency-values form-row">
                          <div className="frequency-number">
                            <CustomInput
                              className="custom-form-input mt-2"
                              placeholder="Enter a number"
                              name="throttleTypeValue"
                              allowedRegex={NumericRegex}
                            />
                          </div>
                          <div className="frequency-type">
                            <SingleFormikSelect
                              required
                              data={throttleTypes}
                              name="throttleType"
                              optionLabelProp="name"
                              optionValueProp="id"
                              placeholder="Select"
                              customClass="mt-2"
                              allowClear={false}
                              sort={false}
                              onChange={(val) => {
                                setFieldValue("throttleType", val);
                                setFieldTouched("throttleTypeValue", true);
                                setTimeout(validateForm, 0);
                              }}
                            />
                          </div>
                        </section>
                      </div>
                    </>
                  )}
                </CustomModal>
              </Form>
            );
          }}
        </Formik>
      )}
    
      <Layout testId="broadcast-main-page-wrapper">
        
        <div className="inner-content-wrapper broadcast-desktop">
          <Card
            className="primary-card broadcast-card"
            title={
              <span className="broadcast-custom-header">
                <p className="heading hide-for-tab">Broadcast</p>

                <>
                  <AntRadioLarge
                    options={[
                      { name: "Patient", value: "patient" },
                      { name: "Appointments", value: "apiPatient" },
                      ...(!PRACTICE_EDITION_WHITELABEL
                        ? [
                            {
                              name: "Employee",
                              value: "employee",
                            },
                          ]
                        : []),
                      ...(width > MOBILE_WIDTH && PRACTICE_EDITION_WHITELABEL
                        ? [{ name: "Template", value: "template" }]
                        : []),
                    ]}
                    value={activeTab}
                    handleChange={(e) => toggle(e.target.value)}
                  />
                </>
                {state.isRcsForBroadcast &&
                  state.isRcsEnableAccountLevel && (
                    <span className="rcs-badge">
                      {rcsIconMain}
                      <span style={{ marginLeft: 4 }}>RCS Enabled</span>
                    </span>
                  )}
              </span>
            }
            extra={
              <>
                <CustomButton
                  title={
                    <div className="icon-button message-icon">
                      <SettingsIcon />
                      Adjust Throttle
                    </div>
                  }
                  tooltip="Adjust Throttle"
                  btntype="primary"
                  className={"cancel-button ml-8 reports-button message-log"}
                  onClick={showThrottlePopup}
                />
                <CustomButton
                  title={
                    <div className="icon-button message-icon">
                      <MessageLogIcon />
                      Message Log
                    </div>
                  }
                  tooltip="Message Log"
                  btntype="primary"
                  className={"cancel-button ml-8 reports-button message-log"}
                  onClick={showMessageLog}
                />
                <CustomButton
                  title={
                    <div className="icon-button">
                      <ReportsButtonIcon />
                      Broadcast Report
                    </div>
                  }
                  tooltip="Broadcast Report"
                  btntype="primary"
                  className={"cancel-button ml-8 reports-button broadcast-log"}
                  onClick={showReports}
                />
              </>
            }
          >
            <div className="broadcast-main-container">
              <>
                {activeTab === "patient" ? (
                  <PatientBroadcast
                    editDeleteAccess={editDeleteAccess}
                    updateStatus={updateStatus}
                    handleEmailTemplateData={handleEmailTemplateData}
                  />
                ) : null}

                {activeTab === "employee" ? (
                  <EmployeeBroadcast
                    editDeleteAccess={editDeleteAccess}
                    updateStatus={updateStatus}
                    handleEmailTemplateData={handleEmailTemplateData}
                  />
                ) : null}

                {activeTab === "apiPatient" ? (
                  <FilterBroadcast
                    updateStatus={updateStatus}
                    handleEmailTemplateData={handleEmailTemplateData}
                  />
                ) : null}

                {activeTab === "template" ? (
                  <Templates
                    updateStatus={updateStatus}
                    emailTemplateData={state.emailTemplateData}
                  />
                ) : null}
              </>

              {uploadStatus ? <LoadingSpinner relative /> : ""}
            </div>
          </Card>
        </div>
        {width < MOBILE_WIDTH && (
          <div className="mobile-content">
            {!state.optionSelected && (
              <MobileHeader
                showLogo={true}
                showNotifications={true}
                showHelp={false}
                showAccountDetails={true}
                backgroundColor=""
              />
            )}
            {!state.optionSelected && (
              <NewBroadcastMob
                showReports={showReports}
                handleChange={toggle}
                showMessageLogs={showMessageLogs}
                showAdjustThrottle={showThrottlePopup}
                isRcsEnabledForBroadcast={
                  state.isRcsForBroadcast && state.isRcsEnableAccountLevel
                }
              />
            )}
            {state.optionSelected && (
              <div className="broadcast-main-container">
                <>
                  {activeTab === "patient" ? (
                    <PatientBroadcast
                      editDeleteAccess={editDeleteAccess}
                      updateStatus={updateStatus}
                      handleBackButton={backButtonClicked}
                      handleEmailTemplateData={handleEmailTemplateData}
                    />
                  ) : null}

                  {activeTab === "employee" ? (
                    <EmployeeBroadcast
                      editDeleteAccess={editDeleteAccess}
                      updateStatus={updateStatus}
                      handleBackButton={backButtonClicked}
                      handleEmailTemplateData={handleEmailTemplateData}
                    />
                  ) : null}

                  {activeTab === "apiPatient" ? (
                    <FilterBroadcast
                      updateStatus={updateStatus}
                      handleBackButton={backButtonClicked}
                      handleEmailTemplateData={handleEmailTemplateData}
                    />
                  ) : null}

                  {activeTab === "template" ? (
                    <Templates
                      updateStatus={updateStatus}
                      emailTemplateData={state.emailTemplateData}
                    />
                  ) : null}
                </>

                {uploadStatus ? <LoadingSpinner relative /> : ""}
              </div>
            )}
          </div>
        )}
        {!state.optionSelected && <MobileMenu component="broadcast" />}
      </Layout>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(Broadcast);
